import { MovementReconciliationActions } from '../bancos/MovementReconciliationActions';
import { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { Dialog, IconButton, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import moment from 'moment';

import './payments.css';

import { usePay } from '../../hooks/usePay'
import { PaymentsModal } from './PaymentsModal';

export const PaymentsModalList = ({ compraId, dataCompra, title, openModal, setModal, checkInitialData }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // móvil: sm o menor

    const { listaCtasBancarias } = useSelector(state => state.general)
    const { detailPay, pays, initGetAllPayByGasto, initGetOnePay, initDeletePay } = usePay()
    const [paymentsModal, setPaymentsModal] = useState(false)

    const handleDeletePay = async (payId) => {
        const deleted = await initDeletePay(payId);
        if (!deleted) return false;
        await initGetAllPayByGasto(compraId)
        if (typeof checkInitialData === 'function') await checkInitialData(compraId)

        /* console.log('--pays?.length--', pays) */
        if (pays?.length === 0) {
            setModal(false)
        }

        return true;
    }

    const handleEditPay = async (payId) => {
        await initGetOnePay(payId)
        setPaymentsModal(true)
    }

    useEffect(() => {
        initGetAllPayByGasto(compraId)
    }, [initGetAllPayByGasto, compraId])

    return (
        <>

            {paymentsModal &&
                <PaymentsModal
                    initialPay={detailPay}
                    title={'Pago emitido'}
                    openModal={paymentsModal}
                    setModal={setPaymentsModal}
                    dataCompra={dataCompra}
                    checkInitialData={checkInitialData}
                    initGetAllPayByGasto={initGetAllPayByGasto}
                />
            }


            <Dialog
                className='dialogModalList'
                open={openModal}
                onClose={() => setModal(false)}
                aria-labelledby="simple-dialog-title"
                fullScreen={isMobile}
                PaperProps={{
                    className: isMobile ? '' : (pays.length > 0 ? 'min-w-[80%]' : 'w-100')
                }}
            >
                <div className='ContainerDialogs'>
                    <h1 className='title-lista-pagos'>
                        {title}
                        <IconButton
                            style={{ padding: '0', float: 'right' }}
                            aria-label="close"
                            onClick={() => setModal(false)}
                        >
                            <CloseIcon />
                        </IconButton>
                    </h1>

                    <div className="table-responsive">
                        <table className="table p-table-global lista-pagos">
                            <thead className='p-thead-global'>
                                <tr className="text-center p-tr-titles-global">
                                    <th scope="col">Proveedor</th>
                                    <th scope="col">Fecha de pago</th>
                                    <th scope="col">Tipo pago</th>
                                    <th scope="col">Cuenta bancaria</th>
                                    <th scope="col">Nro. de operación</th>
                                    <th scope="col">Total pagado</th>
                                    <th scope="col">Link</th>
                                    <th scope="col" className='text-start'>Detalle</th>
                                    <th scope="col">Conciliación / acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pays?.map(item => (
                                    <tr className="text-center p-tr-body-global" key={item.id}>
                                        <td>{item.proveedor || 'Ninguno'}</td>
                                        <td>{moment(item.fecha_pago).format('DD-MM-YYYY') || 'Ninguno'}</td>
                                        <td>{item.tipo_pago_nombre || 'Ninguno'}</td>
                                        {/* <td>{item.nombre_cta_bancaria || 'Ninguno'}</td> */}
                                        <td className='text-start'>
                                            {listaCtasBancarias?.find(c => parseInt(c.id) === parseInt(item.id_cta_bancaria))?.nombre || 'Ninguno'}
                                        </td>
                                        <td>{item.nro_operacion || 'Ninguno'}</td>
                                        <td>
                                            <NumberFormat
                                                value={item.total_pago}
                                                displayType={'text'}
                                                thousandSeparator={item.separacion_miles}
                                                decimalSeparator={item.separacion_decimales}
                                                decimalScale={2}
                                                prefix={`${item.simbolo} `}
                                            />
                                        </td>
                                        <td>
                                            {(item?.url_boucher !== null && item?.url_boucher !== '') ?
                                                <a
                                                    className='p-links'
                                                    href={item?.url_boucher || ''}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Ver boucher
                                                </a>
                                                :
                                                <span style={{ textTransform: 'none' }}>---</span>
                                            }
                                        </td>
                                        <td className='text-start'>
                                            {item.ids_item_compra.length > 0 ?
                                                item.ids_item_compra.map((it, index) => (
                                                    <span className='m-1 lowercase'>
                                                        {it?.referencia}
                                                        {(index + 1) !== item.ids_item_compra.length ? ',' : ''}
                                                    </span>
                                                ))
                                                :
                                                '---'
                                            }
                                        </td>
                                        <td>
                                            <MovementReconciliationActions movement={item} type="egreso" onEdit={() => handleEditPay(item.id)} onDelete={() => handleDeletePay(item.id)}
                                                onChanged={async () => { await initGetAllPayByGasto(compraId); if (typeof checkInitialData === 'function') await checkInitialData(compraId); }} />
                                        </td>
                                    </tr>
                                ))
                                }
                            </tbody>
                        </table>
                    </div>

                </div>
            </Dialog>
        </>
    )
}
